/**
 * Filter utility functions for TanStack Table
 */

import { normalizeString } from './stringHelpers';

/**
 * Accent-insensitive global filter function for TanStack Table
 * Searches across specified fields in a row, ignoring accents
 *
 * This filter is applied globally to ResponsiveDataList tables,
 * enabling accent-insensitive search across the entire application.
 *
 * @param {Object} row - TanStack Table row object
 * @param {string} columnId - Column ID (not used, required by TanStack Table signature)
 * @param {string} filterValue - Search/filter value entered by user
 * @returns {boolean} True if row matches filter, false otherwise
 *
 * @example
 * // Searching "garcia" will match "García", "garcia", "GARCIA"
 * // Searching "jose" will match "José", "jose", "JOSE"
 */
export function accentInsensitiveFilter(row, columnId, filterValue) {
  const searchValue = normalizeString(filterValue);

  // Get all searchable string values from the row
  const searchableValues = Object.values(row.original)
    .filter(value => typeof value === 'string')
    .map(value => normalizeString(value));

  // Check if any field contains the search value
  return searchableValues.some(value => value.includes(searchValue));
}
